import {
  createAppMessageCashierMirrorTransport,
  createCashierMirrorOperator,
  resetMirrorPeerReady,
  type CashierMirrorOperator,
} from '@nsftx/seven-client-retail-cashier-mirror-core'
import { forwardAppMessage, subscribeDisplayMessages } from '@nsftx/seven-client-retail-vue-dm'
import { logService } from '@nsftx/seven-client-retail-utils'
import { pushCashierMirrorActiveToIntegrator } from './integratorCashierMirrorSettings.ts'

const LOG_PREFIX = '[cashierMirrorPosService]'

let operator: CashierMirrorOperator | null = null
let initialized = false

export const initCashierMirrorPos = () => {
  if (initialized) {
    return
  }

  initialized = true
  resetMirrorPeerReady()

  const transport = createAppMessageCashierMirrorTransport({
    publish: forwardAppMessage,
    subscribe: (handler) => subscribeDisplayMessages(handler),
  })

  operator = createCashierMirrorOperator({ transport })

  operator.onMirrorReady(() => {
    logService.info(`${LOG_PREFIX} Cashier Mirror peer ready.`, {
      code: 'SS_CASHIER_MIRROR_PEER_READY',
    })
    pushCashierMirrorActiveToIntegrator()
  })
  operator.checkMirrorStatus()

  logService.debug(`${LOG_PREFIX} Cashier Mirror operator initialized.`, {
    code: 'SS_CASHIER_MIRROR_OPERATOR_INIT',
  })
}

export const teardownCashierMirrorPos = () => {
  operator = null
  initialized = false
}
